import "./GarageDoorInstallationSydney.module.css";
import Header from "@/reusable_sections/Header";
import Installation from "./sections/Installation";
import DoorTypes from "./sections/DoorTypes";
import GarageBenefits from "./sections/GarageBenefits";
import InstallationPricing from "./sections/InstallationPricing";
import Installationfaq from "./sections/Installationfaq";
import WhyChooseInstallation from "./sections/WhyChooseInstallation";
import GarageDoorFAQ from "./sections/GarageDoorFAQ";
import TrustPillarsHero from "./sections/TrustPillarsHero";
import ServiceArea from "./sections/ServiceArea";
import Footer from "./sections/Footer";
export default function GarageDoorInstallationSydneyPage() {
  return <div>
      <Header />
      <Installation />
      <Installation />
      <DoorTypes />
      <Installation />
      <GarageBenefits />
      <InstallationPricing />
      <Installation />
      <Installationfaq />
      <WhyChooseInstallation />
      <GarageDoorFAQ />
      <TrustPillarsHero />
      <ServiceArea />
      <Footer />
      <Installation />
    </div>;
}